import { logEvent } from 'commons/utils/tracking';
import {
  MORE_DISCOUNTS_MODAL_OPTION_CLICK,
  MORE_DISCOUNTS_MODAL_OPENED,
  MORE_DISCOUNTS_MODAL_OPTION_CREATED,
} from 'config/trackingEvents';

export const logMoreDiscountsModalOpened = (listPage: string) => {
  logEvent(MORE_DISCOUNTS_MODAL_OPENED, { listPage });
};

export const logMoreDiscountsModalOptionClick = (optionId: string) => {
  logEvent(MORE_DISCOUNTS_MODAL_OPTION_CLICK, { optionId });
};

export const logMoreDiscountsModalOptionCreated = (optionId: string) => {
  logEvent(MORE_DISCOUNTS_MODAL_OPTION_CREATED, { optionId });
};
